  window.addEventListener('DOMContentLoaded', () => {
    const isSmallViewport = window.matchMedia('(max-width: 749px)');

    const initFooterToggle = () => {
      const headings = document.querySelectorAll('.grid .footer-block__heading');

      const handleCollapse = (clickedHeading) => {
        headings.forEach((heading) => {
          const content = heading.nextElementSibling;

          if (heading === clickedHeading) {
            // Toggle the clicked heading
            if (heading.classList.contains('block-collapsed')) {
              heading.classList.remove('block-collapsed');
              heading.setAttribute('aria-expanded', 'true');
              content.style.maxHeight = `${content.scrollHeight}px`; // Smoothly expand
            } else {
              heading.classList.add('block-collapsed');
              heading.setAttribute('aria-expanded', 'false');
              content.style.maxHeight = '0'; // Smoothly collapse
            }
          } else {
            // Collapse other headings
            heading.classList.add('block-collapsed');
            heading.setAttribute('aria-expanded', 'false');
            content.style.maxHeight = '0';
          }
        });
      };

      headings.forEach((heading, index) => {
        heading.classList.add('block-collapsed');
        heading.setAttribute('role', 'button');
        heading.setAttribute('aria-expanded', 'false');
        heading.setAttribute('tabindex', '0');

        const content = heading.nextElementSibling;
        content.setAttribute('id', `footer-block-index-${index}`);
        heading.setAttribute('aria-controls', `footer-block-index-${index}`);
        content.style.maxHeight = '0'; // Ensure all content starts hidden
        content.style.overflow = 'hidden'; // Prevent overflow
        content.style.transition = 'max-height 0.3s ease-out'; // Smooth animation

        heading.addEventListener('click', () => {
          handleCollapse(heading);
        });

        heading.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            handleCollapse(heading);
          }
        });
      });
    };

    const destroyFooterToggle = () => {
      const headings = document.querySelectorAll('.grid .footer-block__heading');
      headings.forEach((heading) => {
        const content = heading.nextElementSibling;

        // Reset styles and attributes
        heading.classList.remove('block-collapsed');
        heading.removeAttribute('role');
        heading.removeAttribute('aria-expanded');
        heading.removeAttribute('tabindex');
        heading.removeAttribute('aria-controls');

        if (content) {
          content.style.maxHeight = ''; // Reset max-height
          content.style.overflow = ''; // Reset overflow
          content.style.transition = ''; // Reset transition
        }
      });
    };

    const handleViewportChange = (event) => {
      if (event.matches) {
        initFooterToggle(); // Apply functionality for max-width: 749px
      } else {
        destroyFooterToggle(); // Remove functionality for min-width: 750px
      }
    };

    // Attach event listener to monitor viewport changes
    isSmallViewport.addEventListener('change', handleViewportChange);

    // Initial check on page load
    if (isSmallViewport.matches) {
      initFooterToggle();
    } else {
      destroyFooterToggle();
    }
  });
